var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgZoomSolid = function SvgZoomSolid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7408 19.2878L17.8318 15.3854C17.6363 15.2293 17.4018 15.1122 17.1672 15.1122H16.5418C17.5972 13.7463 18.2618 12.0293 18.2618 10.1171C18.2618 5.66829 14.5872 2 10.1309 2C5.63544 2 2 5.66829 2 10.1171C2 14.6049 5.63544 18.2341 10.1309 18.2341C12.0072 18.2341 13.7272 17.6098 15.1345 16.5171V17.1805C15.1345 17.4146 15.2127 17.6488 15.4081 17.8439L19.2781 21.7073C19.669 22.0976 20.2554 22.0976 20.6072 21.7073L21.7017 20.6146C22.0926 20.2634 22.0926 19.678 21.7408 19.2878ZM10.1309 15.1122C7.35543 15.1122 5.12726 12.8878 5.12726 10.1171C5.12726 7.38537 7.35543 5.12195 10.1309 5.12195C12.8672 5.12195 15.1345 7.38537 15.1345 10.1171C15.1345 12.8878 12.8672 15.1122 10.1309 15.1122Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgZoomSolid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/zoom_solid.03dff5da.svg";
export { ForwardRef as ReactComponent };